/**
 * While editing: allow Unicode letters, Unicode numbers, spaces, and commas only.
 * Does not convert spaces to commas.
 */
export function sanitizeBadIspWordsDraft(raw: string): string {
	if (!raw) {
		return '';
	}
	return raw.replace(/[^\p{L}\p{N} ,]/gu, '');
}

/**
 * Wire / save: whitespace → comma, strip disallowed chars, collapse commas, trim edges.
 * Use for Apply payload, dirty comparison (`normalizeBadIspText`), and post-success model value.
 */
export function sanitizeBadIspWordsInput(raw: string): string {
	if (!raw) {
		return '';
	}
	let s = raw.replace(/\s+/g, ',');
	s = s.replace(/[^\p{L}\p{N},]/gu, '');
	s = s.replace(/,+/g, ',');
	s = s.replace(/^,+|,+$/g, '');
	return s;
}

export function normalizeBadIspText(value: string | undefined): string {
	return sanitizeBadIspWordsInput(value ?? '');
}
